import { useEffect, useState, useCallback } from "react"
import ApiService from "../../services/apiService";
import Loader from "../../elements/Loader";
import Pagination from "../../elements/Pagination";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const Refund = () => {

    const [refund, setRefund] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [loading, setLoading] = useState(false);

    const getRefund = useCallback(() => {
        setLoading(true)
        ApiService.get(`refund?page=${currentPage + 1}&limit=10`).then((result) => {
            setLoading(false)
            // Convert updatedAt to IST before setting booking data
            const refundWithIST = result.data.map((dp) => ({
                ...dp,
                updatedAt: convertToIST(dp.updatedAt),
                createdAt: convertToIST(dp.createdAt),
            }));
            setRefund(refundWithIST)
            setPageCount(result.data.totalPages)
        }).catch((error) => {
            console.log(error)
            setLoading(false)
        })
    }, [currentPage]);
    const convertToIST = (utcDate) => {
        const date = new Date(utcDate);
        return date.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
    };
    const handlePageClick = (selectedPage) => {
        const clickedPage = selectedPage.selected;
        if (clickedPage !== currentPage) {
            setCurrentPage(clickedPage);
        }
    }
    const refundCompleted = (bookingId) => {
        const userConfirmed = window.confirm("Are you sure you want to take this action?");
        if (userConfirmed) {

            ApiService.put(`refund`, {bookingId}).then((result)=>{
                if(result.msg === 'success') {
                    toast.success('Refund Marked as Done')
                }
            }).catch( (error)=> {
                toast.error('something wrong!')
            })
        } else {
            // Cancel the action
            console.log("Action canceled!");
        }
        getRefund();
    }
    useEffect(() => {
        getRefund()
    }, [getRefund])
    return (
        <div className="row">
            <div className="col-xl-12">
                {loading && <Loader />}
                <div className="card dz-card" id="bootstrap-table2">
                    <div className="card-header flex-wrap d-flex justify-content-between  border-0">
                        <div>
                            <h4 className="card-title">Refund List</h4>
                        </div>
                    </div>
                    {/* tab-content */}

                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-responsive-md">
                                <thead>
                                    <tr>

                                        <th>
                                            <strong>Booking Id</strong>
                                        </th>
                                        <th>
                                            <strong>Payment Id</strong>
                                        </th>

                                        <th>
                                            <strong>Amount</strong>
                                        </th>
                                        <th>
                                            <strong>Status</strong>
                                        </th>
                                        <th>
                                            <strong>Created At</strong>
                                        </th>
                                        <th>
                                            <strong>Updated At</strong>
                                        </th>
                                        <th>
                                            <strong>Action</strong>
                                        </th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {refund && refund?.length > 0 && refund.map((dp, key) => {
                                        return (
                                            <tr>

                                                <td>
                                                    <div className="d-flex align-items-center">

                                                        <span className="w-space-no">
                                                            <Link to={`/edit-booking/${dp.bookingId}`} className="text-blue-500" >{dp.bookingId}</Link>

                                                        </span>
                                                    </div>
                                                </td>

                                                <td>
                                                    <div className="d-flex align-items-center">

                                                        <span className="w-space-no">{dp?.paymentId}</span>
                                                    </div>
                                                </td>


                                                <td>
                                                    <div className="d-flex align-items-center">

                                                        <span className="w-space-no">{dp?.amount}</span>
                                                    </div>
                                                </td>

                                                <td>
                                                    <div className="d-flex align-items-center">

                                                        <span className="w-space-no">{dp?.status}</span>
                                                    </div>
                                                </td>

                                                <td>
                                                    <div className="d-flex align-items-center">

                                                        <span className="w-space-no">{dp?.createdAt}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="d-flex align-items-center">

                                                        <span className="w-space-no">{dp?.updatedAt}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    {dp.status === 'pending' && (

                                                        <button className="btn btn-primary" onClick={() => refundCompleted(dp.bookingId)}>Processed</button>
                                                    )}
                                                </td>

                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>

                            <Pagination pageCount={pageCount} handlePageClick={handlePageClick} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Refund;